module.exports = __webpack_public_path__ + "static/media/Image3.5331645b.png";